import "./OrganizationStructure.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Heroorganisasipp from "./sections/Heroorganisasipp";
import Nationalorganizationhierarchy from "./sections/Nationalorganizationhierarchy";
import Organizationalstructure from "./sections/Organizationalstructure";
import MajelisPertimbanganOrganisasi from "./sections/MajelisPertimbanganOrganisasi";
import DewanKehormatan from "./sections/DewanKehormatan";
import DewanPakar from "./sections/DewanPakar";
import OrganizationalWings from "./sections/OrganizationalWings";
import MpwJawaBaratStructure from "./sections/MpwJawaBaratStructure";
import MpcGarutPilotProject from "./sections/MpcGarutPilotProject";
import ZonaPPNewsGrid from "./sections/ZonaPPNewsGrid";
import FooterOrganisasi from "./sections/FooterOrganisasi";
import Stickysubheronavigation from "./sections/Stickysubheronavigation";
import Secretariatcontact from "./sections/Secretariatcontact";
export default function OrganizationStructurePage() {
  return <div>
      <Header />
      <Heroorganisasipp />
      <Stickysubheronavigation />
      <Nationalorganizationhierarchy />
      <Organizationalstructure />
      <MajelisPertimbanganOrganisasi />
      <DewanKehormatan />
      <DewanPakar />
      <OrganizationalWings />
      <MpwJawaBaratStructure />
      <MpcGarutPilotProject />
      <ZonaPPNewsGrid />
      <Secretariatcontact />
      <FooterOrganisasi />
      <Footer />
    </div>;
}